/** Web app secure launch (M29, WP-M29-LAUNCH-WEB): the launch page, the state-bound start, the dead end and "Chatting as". Mirrors `en/webapp-launch.ts` key for key. */
export const webappLaunch = {
  launching: {
    title: "Binubuksan ang chat mo",
    body: "Ligtas ka naming sine-sign in…",
  },
  rateLimited: {
    body: "Masyadong maraming subok ngayon. Maghintay sandali at subukan muli.",
    retry: "Subukan muli",
  },
  deadEnd: {
    title: "Nag-expire na ang link ng chat na ito",
    body: "Isang beses lang gumagana ang mga link at sandali lang, para manatiling pribado ang mga record mo. Simulan muli ang chat mula sa site.",
    returnTo: "Bumalik sa {{site}}",
    note: "Walang impormasyon tungkol sa iyo na naibahagi sa link na ito.",
  },
  start: {
    title: "Dinadala ka sa sign-in",
    body: "Ibabalik ka namin dito na naka-sign in.",
  },
  verifiedOnly: {
    title: "Buksan ang chat na ito mula sa site",
    body: "Para sa mga na-verify na customer ang assistant na ito. Buksan ito mula sa site ng {{org}}, o mag-sign in sa ibaba.",
  },
  header: {
    chattingAs: "Kausap bilang {{name}}",
    chattingAsTier: "Kausap bilang {{name}} · {{tier}}",
    customerFallback: "Customer",
    returnTo: "Bumalik sa {{site}}",
  },
  embed: {
    reconnecting: {
      title: "Ikinokonekta ka ulit sa chat",
      body: "Ligtas ka naming sine-sign in muli…",
    },
    ended: {
      title: "Natapos na ang session ng chat mo",
      body: "Kusang nagsasara ang mga chat pagkalipas ng ilang sandali para manatiling pribado ang mga record mo. Kumonekta ulit para magpatuloy, o i-reload ang page na kinalalagyan ng chat na ito.",
      reconnect: "Kumonekta ulit",
      failed: "Hindi kami nakakonekta ulit mula rito. I-reload ang page na kinalalagyan ng chat na ito para magpatuloy.",
    },
  },
  oidc: {
    button: "Mag-sign in gamit ang {{org}} account mo",
    buttonHint: "Pupunta ka sa sariling sign-in ng {{org}} at babalik agad dito.",
    redirecting: "Dinadala ka para mag-sign in…",
    framedTitle: "Buksan ang chat mula sa site ng {{org}}",
    framedBody: "Hindi puwedeng tumakbo sa loob ng page na ito ang pag-sign in gamit ang {{org}} account. Buksan ang chat mula sa site ng {{org}} at awtomatiko kang masa-sign in.",
    errors: {
      failed: "Hindi ka namin na-sign in gamit ang {{org}} account mo. Subukan ulit, o gumamit ng ibang paraan sa ibaba.",
      unavailable: "Hindi available ngayon ang pag-sign in gamit ang {{org}} account mo. Subukan ulit mamaya, o gumamit ng ibang paraan sa ibaba.",
      framed: "Hindi puwedeng tumakbo sa loob ng frame ang pag-sign in gamit ang {{org}} account mo. Buksan ang chat mula sa site ng {{org}}.",
      expired: "Natagalan o nagamit na ang sign-in na iyon. Magsimula ulit.",
      blocked: "Hindi magagamit ng account na ito ang chat. Makipag-ugnayan sa {{org}} kung sa tingin mo ay pagkakamali ito.",
    },
  },
} as const;
